export const yearStart = 2017;
export const owner = 'Maxime Tavernier';